import React, {forwardRef,useImperativeHandle,useState,useEffect} from 'react'
import RadioInput from './RadioInput';

const ZeroToTenQuestion = forwardRef((props,ref)=> {
    const [value,setValue] = useState(null);
    const text = props.text;
    const [radios,setRadios] = useState([]);
    const [alert,setAlert] = useState(false);
    const [comment,setComment] = useState('');
    const [showComment,setShowComment] = useState(false);
    const name = props.name;
    const update = props.update; 
    const updateComment = props.updateComment;

    const switchAlert = function(){
        if(value==null){
            setAlert(true);
        }
    }

    useImperativeHandle(ref,()=>({
        switchAlert:switchAlert
    }));

    useEffect(()=>{
        let res = [];

        // Generate options 0-10
        for(let i=0; i<=10; i++){
            // Values with labels: 0, 10
            if(i === 0 || i === 10){
                let labelText = '';
                if(i === 0) labelText = 'Not at all likely';
                else if(i === 10) labelText = 'Extremely likely';

                res.push(
                    <td className='text-center' key={name+i}>
                        <div>
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name={name} 
                                id={name+i} 
                                value={i} 
                                onClick={()=>{
                                    setValue(i);
                                    setAlert(false);
                                    setShowComment(false);
                                }}
                            />
                        </div>
                        <div style={{fontSize: '0.75rem', marginTop: '2px', fontWeight: 'bold'}}>{labelText}</div>
                    </td>
                );
            } else {
                // Unlabeled values: 1, 2, 3, 4, 5, 6, 7, 8, 9 - use RadioInput for consistency
                res.push(<RadioInput name={name} id={name+i} key={name+i} value={i} updateVal = {()=>{
                    setValue(i);
                    setAlert(false);
                    setShowComment(false);
                }}/>);
            }
        }

        setRadios(res);
    },[]);

    useEffect(()=>{
        if(value != null){
            // Store the value: 0-10 for scale values
            update(value);
        }
    },[value])

    useEffect(()=>{
        updateComment(comment);
    },[comment])

    return (
        <>
            <tr style={alert? {backgroundColor:'#ffe6e6'}:{}}>
                <td>{text}</td>
                {radios}
            </tr>
            {
                showComment &&
                <tr>
                    <td colSpan={12} style={{paddingLeft:'30%'}}>
                        <textarea className='form-control' type='text' value={comment} placeholder='(Optional) Please provide your feedback on how we could do better in this area.' onChange={(e)=>{setComment(e.target.value)}}></textarea>
                    </td>
                </tr>
            }
        </>
    )
});
export default ZeroToTenQuestion;

